import React from "react";
import './bestPlaces.css';

function BestPlaces() {
    return (
        <div className="bestPlaces">
            <p className="component-name">Best Locations</p>
            <div className="component-head">
                <h2>Indonesian Tourism</h2>
                <p>Extraordinary natural beauty, enjoy the rich culture and experience the friendliness of the local people.</p>
            </div>
            <div className="places-grid" id="grid1">
                <div className="place-card place-card-large place-card-1">
                    <div className="place-card-content">
                        <h3>Bromo</h3>
                        <p>Majestic Volcanic Beauty</p>
                    </div>
                </div>
                <div className="place-card place-card-small place-card-2">
                    <div className="place-card-content">
                        <h3>Bali</h3>
                        <p>Island of Gods</p>
                    </div>
                </div>
            </div>
            <div className="places-grid" id="grid2">
                <div className="place-card place-card-small place-card-3">
                    <div className="place-card-content">
                        <h3>Lampung</h3>
                        <p>Gateway to Sumatra's Wonders</p>
                    </div>
                </div>
                <div className="place-card place-card-large place-card-4">
                    <div className="place-card-content">
                        <h3>Mount Fuji</h3>
                        <p>Iconic Japanese Peak</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BestPlaces;
